(function () {
    'use strict';

    var app = angular.module('app');

    app.factory('swaggerService', ['$q', '$filter', '$resource', '$sce', 'common', 'config', 'storageService', 'swaggerModel', 'swaggerModules', 'swaggerOperationModelFactory', swaggerService]);

    function swaggerService($q, $filter, $resource, $sce, common, config, storageService, swaggerModel, swaggerModules, swaggerOperationModelFactory) {
        var storageKey = "swaggerServiceSessionKey";
        var swaggerFileMetadataList = null;
        var swaggerFiles = null;

        var SwaggerFileMetadataResource = null;
        var SwaggerFileResource = null;

        var service = {
            activationPromise: null,
            getApiList: getApiList,
            getOperationsByApiId: getOperationsByApiId,
            getOperationByApiIdAndOperationId: getOperationByApiIdAndOperationId,
            userSignOut: userSignOut
        };

        activate();
        return service;

        function activate() {
            service.activationPromise = common.handleBusyState([initializeData(), initializeResources()], 'swaggerService');
        }

        //#region Public Methods

        function userSignOut() {
            $resource(config.servicesUrl.api.swaggerFileResourceUrl, { apiId: '@apiId' });
        }

        function getApiList() {
            return getSwaggerFileMetadataList();
        }

        function getOperationsByApiId(apiId) {
            return getSwaggerFile(apiId).then(function (swaggerFile) {
                if (swaggerFile)
                    return swaggerOperationModelFactory.convertToSwaggerOperations(swaggerFile.data.form, swaggerFile.data.resources, swaggerFile.swagger);
                return $q.when([]);
            });
        }

        function getOperationByApiIdAndOperationId(apiId, operationId) {
            return getOperationsByApiId(apiId).then(function (swaggerOperations) {
                var operationSearchResults = $filter('filter')(swaggerOperations, function (swaggerOperation) {
                    return swaggerOperation.operation.operationId === operationId;
                });
                if (operationSearchResults && operationSearchResults.length == 1)
                    return operationSearchResults[0];

                return null;
            });
        }

        //#endregion

        //#region Private Methods
        function initializeData() {
            // load data from cache (if any)
            var cache = storageService.getItem(storageKey);
            if (cache) {
                swaggerFileMetadataList = cache.swaggerFileMetadataList;
                swaggerFiles = cache.swaggerFiles;

                // need to regenerate some html that was not saved in cache
                angular.forEach(swaggerFiles, function (swaggerFile) {
                    angular.forEach(swaggerFile.file.data.resources, function (resource) {
                        angular.forEach(resource.operations, function (operation) {
                            operation.responseClass.schema.model = $sce.trustAsHtml(swaggerModel.generateModel(swaggerFile.file.swagger, operation.responseClass.schema));
                        })
                    })
                })
                //param.schema.model = $sce.trustAsHtml(swaggerModel.generateModel(swagger, param.schema));
            }
            else 
                swaggerFiles = [];

            return $q.when();
        }

        function initializeResources() {
            SwaggerFileMetadataResource = $resource(config.servicesUrl.api.swaggerFileMetadataResourceUrl, { apiId: '@apiId' });
            SwaggerFileResource = $resource(config.servicesUrl.api.swaggerFileResourceUrl, { apiId: '@apiId' });

            return $q.when();
        }

        function getSwaggerFileMetadataList() {
            // If cached data, return it
            if (swaggerFileMetadataList)
                return $q.when(swaggerFileMetadataList);

            // Call API if no cached data
            return callApiToGetSwaggerFileMetadata().then(function (swaggerFileMetadata) {
                swaggerFileMetadataList = swaggerFileMetadata;
                saveData();
                return swaggerFileMetadataList;
            });
        }

        function getSwaggerFile(apiId) {
            // Try and find matching API id in cache
            var swaggerFile = findSwaggerFileFor(apiId);
            if (swaggerFile)
                return $q.when(swaggerFile);

            // Call API if no cached data found
            return callApiToGetSwaggerFile(apiId)
                .then(function (swaggerFile) {
                    if (swaggerFile) {
                        return parseSwaggerFileJson(swaggerFile).then(function (parsedFile) {
                            swaggerFiles.push({
                                id: apiId, file: parsedFile
                            });
                            saveData();
                            return parsedFile;
                        });
                    }

                    return $q.when(null);
                });
        }

        function parseSwaggerFileJson(swaggerFileJson) {
            var deferred = $q.defer();

            var swagger = swaggerFileJson;
            swaggerModules
                .execute(swaggerModules.BEFORE_PARSE, null, swagger)
                .then(function () {
                    var parseResult = {};
                    // execute modules
                    swaggerModules
                        .execute(swaggerModules.PARSE, 'auto', null, 'application/json', swagger, false, parseResult)
                        .then(function (executed) {
                            if (executed) {
                                var parsedData = { data: parseResult, swagger: swagger };
                                deferred.resolve(parsedData);
                            } else {
                                onAngularSwaggerUiError({
                                    code: 415,
                                    message: 'Could not parse data for Swagger descriptor.'
                                });
                                deferred.resolve(false);
                            }
                        })
                        .catch(onAngularSwaggerUiError);
                })
                .catch(onAngularSwaggerUiError);

            return deferred.promise;
        }

        function saveData() {
            var cache = {
                swaggerFileMetadataList: swaggerFileMetadataList,
                swaggerFiles: swaggerFiles
            };
            storageService.setItem(storageKey, cache);
        }

        function deleteData() {
            storageService.removeItem(storageKey);
        }

        function findSwaggerFileMettadataFor(apiId) {
            var swaggerFileMetadataSearchResult = $filter('filter')(swaggerFileMetadataList, function (swaggerFileMetadata) {
                return swaggerFileMetadata.id === apiId;
            });
            if (swaggerFileMetadataSearchResult && swaggerFileMetadataSearchResult.length == 1)
                return swaggerFileMetadataSearchResult[0];

            return null;
        }

        function findSwaggerFileFor(apiId) {
            var swaggerFileSearchResult = $filter('filter')(swaggerFiles, function (swaggerFile) {
                return swaggerFile.id === apiId;
            });
            if (swaggerFileSearchResult && swaggerFileSearchResult.length == 1)
                return swaggerFileSearchResult[0].file;

            return null;
        }
        //#endregion

        //#region API Calls
        function callApiToGetSwaggerFileMetadata() {
            var deferred = $q.defer();
            SwaggerFileMetadataResource.query(function (resources) {
                var swaggerFileMetadataResources = [];
                resources.forEach(function (resource) {
                    swaggerFileMetadataResources.push(resource);
                });
                deferred.resolve(swaggerFileMetadataResources);
            }, function (error) {
                deferred.resolve(false);
                onApiError(error);
            });
            return deferred.promise;
        }

        function callApiToGetSwaggerFile(id) {
            var deferred = $q.defer();

            SwaggerFileResource.get({ apiId: id }, function (resource) {
                deferred.resolve(resource);
            }, function (error) {
                deferred.resolve(false);
                onApiError(error);
            });
            return deferred.promise;
        }
        //#endregion

        function onApiError(error) {
            throw new Error('Api Error: ' + error.data.LocalizedErrorMessage);
        }

        function onAngularSwaggerUiError(error) {
            throw new Error('AngularSwaggerUI: ' + error.message);
        }
    }
})();